import { Grid } from '@mui/material';
import { useLoadData } from '../../hooks/useLoadData';
import { ApiResponse } from '../../models/api-response';
import { RecentNotes } from './project-details/widgets/recent-notes.component';
import { ProjectStatistics } from './project-details/widgets/project-statistics.component';
import { ProjectInfo } from './project-details/widgets/project-info.component';
import { projectsApiKeyStore } from '../../api/projects-api-key-store';
import { Project } from '../../models/project';
import { DescriptionComponent } from './project-details/widgets/description.component';

interface WidgetsContainerProps {
  projectID?: any;
}

export const WidgetsContainer = ({ projectID }: WidgetsContainerProps) => {
  const { data, isLoading } = useLoadData<ApiResponse<Project>>(projectsApiKeyStore.getProjectDetails(projectID));
  return (
    <Grid container justifyContent="space-between" spacing={0}>
      <Grid item lg={4}>
        <ProjectStatistics projectID={projectID} />
      </Grid>
      <Grid item lg={5} sm={5} xl={5} xs={5}>
        <ProjectInfo project={data?.data} isLoading={isLoading} />
      </Grid>
      <Grid item lg={3} sm={3} xl={3} xs={3}>
        <Grid container spacing={2}>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <RecentNotes projectID={projectID} />
          </Grid>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <DescriptionComponent project={data?.data} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
